import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css`
  .social {
    display: grid;
    column-gap: 20px;
    margin: 13px 0;
    grid-template-columns: repeat(4, 24px);
  }

  .social a {
    color: ${redesignedTheme.colors.mineShaft};
  }

  .social a.linkedin:hover {
    color: ${theme.colors.social.linkedin};
  }

  .social a.instagram:hover {
    color: ${theme.colors.social.instagram};
  }

  .social a.facebook:hover {
    color: ${theme.colors.social.facebook};
  }

  .social a.email:hover {
    color: ${theme.colors.royalBlue};
  }

`
